export const redes = {
  facebook: 'https://www.facebook.com/farmatodocolombia/',
  twitter: 'https://twitter.com/farmatodocol/',
  idTwitter: '@farmatodocol',
  youtube: 'https://www.youtube.com/user/FarmatodoColombia/',
  instagram: 'https://www.instagram.com/farmatodocol/'
};
